export const aboutContent = {
  brandName: '99漫画',
  tagline: '发现好漫画，从这里开始',
  intro: '99漫画成立于2024年，是一个专注于免费漫画推荐的平台。我们致力于为广大漫画爱好者提供最优质的漫画资源推荐服务，涵盖韩漫、日漫、国漫等热门类型，打造类似4399漫画网的同类型阅读体验。',
  story: '99漫画的创始团队由一群资深漫画爱好者和互联网技术专家组成。在体验了4399漫画网等平台后，我们发现漫画爱好者们需要一个更加专注、更加便捷的漫画推荐平台。于是，99漫画应运而生。',
  mission: '我们的使命是让每一个喜欢漫画的人都能轻松找到自己想看的漫画。通过精心筛选和智能推荐，99漫画致力于成为连接漫画读者与优质漫画内容的桥梁。',
  reputation: [
    { label: '日活跃用户', value: '50万+' },
    { label: '收录漫画', value: '10万+' },
    { label: '用户好评率', value: '98.6%' },
    { label: '合作平台', value: '200+' },
  ],
  contact: {
    email: 'contact@99manga.com',
    wechat: '99漫画官方',
    weibo: '@99漫画',
    qq: '1234567890',
    address: '中国广东省广州市天河区漫画创意园B座3层',
  },
};